var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-layout-footer",
    [
      _c(
        "q-toolbar",
        {
          staticClass: "q-py-lg footer-desktop mobile-hide",
          style: _vm.$q.platform.is.edge ? "height: 180px" : ""
        },
        [
          _c("div", { staticClass: "row fit justify-center" }, [
            _c("div", { staticClass: "col-sm-10" }, [
              _c("div", { staticClass: "row gutter-md" }, [
                _c("div", { staticClass: "col-3" }, [
                  _c(
                    "div",
                    { staticClass: "row  gutter-xs flex justify-center" },
                    [
                      _c("div", { staticClass: " col-12 logo text-center" }, [
                        _c("img", {
                          staticClass: "logo-footer-desktop",
                          attrs: { src: _vm.getLogo }
                        })
                      ]),
                      _vm.urlStoreGoogle && _vm.id_user_language_selected == 1
                        ? _c("div", { staticClass: "col-6" }, [
                            _c("a", { attrs: { href: _vm.urlStoreGoogle } }, [
                              _c("img", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  src: require("assets/store_icons/google_portugues.png")
                                }
                              })
                            ])
                          ])
                        : _vm._e(),
                      _vm.useAppleCodes && _vm.id_user_language_selected == 1
                        ? _c("div", { staticClass: "col-6" }, [
                            _c(
                              "a",
                              {
                                staticStyle: { cursor: "pointer" },
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.open_modal()
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    src: require("assets/store_icons/app_portugues.png")
                                  }
                                })
                              ]
                            )
                          ])
                        : _vm.urlStoreApple &&
                          _vm.id_user_language_selected == 1
                        ? _c("div", { staticClass: "col-6" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.urlStoreApple,
                                  target: "_blank"
                                }
                              },
                              [
                                _c("img", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    src: require("assets/store_icons/app_portugues.png")
                                  }
                                })
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm.urlStoreGoogle && _vm.id_user_language_selected == 2
                        ? _c("div", { staticClass: "col-6" }, [
                            _c("a", { attrs: { href: _vm.urlStoreGoogle } }, [
                              _c("img", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  src: require("assets/store_icons/google_ingles.png")
                                }
                              })
                            ])
                          ])
                        : _vm._e(),
                      _vm.useAppleCodes && _vm.id_user_language_selected == 2
                        ? _c("div", { staticClass: "col-6" }, [
                            _c(
                              "a",
                              {
                                staticStyle: { cursor: "pointer" },
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.open_modal()
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    src: require("assets/store_icons/app_ingles.png")
                                  }
                                })
                              ]
                            )
                          ])
                        : _vm.urlStoreApple &&
                          _vm.id_user_language_selected == 2
                        ? _c("div", { staticClass: "col-6" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.urlStoreApple,
                                  target: "_blank"
                                }
                              },
                              [
                                _c("img", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    src: require("assets/store_icons/app_ingles.png")
                                  }
                                })
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm.urlStoreGoogle && _vm.id_user_language_selected == 3
                        ? _c("div", { staticClass: "col-6" }, [
                            _c("a", { attrs: { href: _vm.urlStoreGoogle } }, [
                              _c("img", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  src: require("assets/store_icons/google_espanhol.png")
                                }
                              })
                            ])
                          ])
                        : _vm._e(),
                      _vm.useAppleCodes && _vm.id_user_language_selected == 3
                        ? _c("div", { staticClass: "col-6" }, [
                            _c(
                              "a",
                              {
                                staticStyle: { cursor: "pointer" },
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.open_modal()
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    src: require("assets/store_icons/app_espanhol.png")
                                  }
                                })
                              ]
                            )
                          ])
                        : _vm.urlStoreApple &&
                          _vm.id_user_language_selected == 3
                        ? _c("div", { staticClass: "col-6" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.urlStoreApple,
                                  target: "_blank"
                                }
                              },
                              [
                                _c("img", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    src: require("assets/store_icons/app_espanhol.png")
                                  }
                                })
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm.urlStoreGoogle && _vm.id_user_language_selected == 4
                        ? _c("div", { staticClass: "col-6" }, [
                            _c("a", { attrs: { href: _vm.urlStoreGoogle } }, [
                              _c("img", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  src: require("assets/store_icons/google_frances.png")
                                }
                              })
                            ])
                          ])
                        : _vm._e(),
                      _vm.useAppleCodes && _vm.id_user_language_selected == 4
                        ? _c("div", { staticClass: "col-6" }, [
                            _c(
                              "a",
                              {
                                staticStyle: { cursor: "pointer" },
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.open_modal()
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    src: require("assets/store_icons/app_frances.png")
                                  }
                                })
                              ]
                            )
                          ])
                        : _vm.urlStoreApple &&
                          _vm.id_user_language_selected == 4
                        ? _c("div", { staticClass: "col-6" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.urlStoreApple,
                                  target: "_blank"
                                }
                              },
                              [
                                _c("img", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    src: require("assets/store_icons/app_frances.png")
                                  }
                                })
                              ]
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("h5", { staticClass: "no-margin q-pb-md" }, [
                      _vm._v(_vm._s(_vm.$t("institutional")))
                    ]),
                    _vm._l(_vm.institutional, function(inst, index) {
                      return _c(
                        "p",
                        { key: index },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: inst.to } } },
                            [_vm._v(_vm._s(_vm.$t(inst.name)))]
                          )
                        ],
                        1
                      )
                    })
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("h5", { staticClass: "no-margin q-pb-md" }, [
                      _vm._v(_vm._s(_vm.$t("questions")))
                    ]),
                    _vm._l(_vm.questions, function(question, index) {
                      return _c(
                        "p",
                        { key: index },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: question.to } } },
                            [_vm._v(_vm._s(_vm.$t(question.name)))]
                          )
                        ],
                        1
                      )
                    })
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("h5", { staticClass: "no-margin q-pb-md" }, [
                      _vm._v(_vm._s(_vm.$t("access")))
                    ]),
                    _vm._l(_vm.links, function(link, index) {
                      return _vm.showLink(link.to)
                        ? _c(
                            "p",
                            { key: index },
                            [
                              _c(
                                "router-link",
                                { attrs: { to: { name: link.to } } },
                                [_vm._v(_vm._s(_vm.$t(link.name)))]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    })
                  ],
                  2
                )
              ])
            ])
          ])
        ]
      ),
      _c(
        "q-toolbar",
        {
          staticClass: "mobile-hide bg-primary",
          staticStyle: { padding: "0px", "min-height": "30px" }
        },
        [
          _c(
            "q-toolbar-title",
            { staticClass: "text-center text-weight-light" },
            [
              _c("small", [
                _vm._v(
                  "Copyright © " +
                    _vm._s(new Date().getFullYear()) +
                    ": " +
                    _vm._s(_vm.getProjectName) +
                    " v" +
                    _vm._s(_vm.getVersion) +
                    "\n\t\t\t\t- Powered by "
                ),
                _c("a", { attrs: { href: "https://take5.com.br" } }, [
                  _vm._v("Take 5 LMS")
                ])
              ])
            ]
          )
        ],
        1
      ),
      _c(
        "q-toolbar",
        { staticClass: "desktop-hide" },
        [
          _c("q-toolbar-title", { staticClass: "text-center" }, [
            _c("div", { staticClass: "logo" }, [
              _c("img", {
                staticClass: "logo-footer",
                attrs: { src: _vm.getLogo }
              })
            ])
          ]),
          _c("q-btn", {
            attrs: { flat: "", round: "", dense: "", icon: "far fa-bars" },
            on: {
              click: function($event) {
                return _vm.openMenu()
              }
            }
          })
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: "80vw",
              maxWidth: "100vw",
              minHeight: "90vh"
            }
          },
          on: {
            hide: function($event) {
              _vm.show_modal = false
            }
          },
          model: {
            value: _vm.show_modal,
            callback: function($$v) {
              _vm.show_modal = $$v
            },
            expression: "show_modal"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_modal = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("download_app")) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("q-table", {
                    attrs: {
                      data: _vm.codes,
                      columns: _vm.columns,
                      loading: _vm.loading,
                      "row-key": "code",
                      "no-data-label": _vm.$t("no_data_avaliable"),
                      "no-results-label": _vm.$t("no_results_found"),
                      "loading-label": _vm.$t("loading_data"),
                      "rows-per-page-label": _vm.$t("items_per_page"),
                      "rows-per-page-options": [5, 10, 50, 100],
                      "binary-state-sort": ""
                    },
                    on: { request: _vm.listCodes },
                    scopedSlots: _vm._u([
                      {
                        key: "top",
                        fn: function(props) {
                          return [
                            _c("div", { staticClass: "col" }),
                            _c("q-btn", {
                              attrs: {
                                color: "primary",
                                icon: "far fa-plus",
                                label: _vm.$t("new_download_code"),
                                disable: _vm.disable_new_code
                              },
                              on: {
                                click: function($event) {
                                  return _vm.generateCode()
                                }
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "header",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            _vm._l(props.cols, function(col) {
                              return _c(
                                "q-th",
                                { key: col.name, attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t(col.label)) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        }
                      },
                      {
                        key: "body",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            [
                              _c(
                                "q-td",
                                {
                                  key: "redemption_link",
                                  attrs: { props: props }
                                },
                                [
                                  _c("q-btn", {
                                    attrs: {
                                      flat: "",
                                      icon: "fal fa-download",
                                      color: "primary"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.openLink(
                                          _vm.getlink(props.row.redemption_link)
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                { key: "code", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(props.row.code) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "created_date",
                                  attrs: { props: props }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.fDate(props.row.created_date)
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }